<ui-dialog
    #deleteConfirmationDialog
    header="{{ 'payroll.deductions.deleteDeduction' | appTranslate }}"
    confirmationDialog
    (closing)="deleteConfirmationDialog.open = false"
    (primaryButtonPressed)="deleteConfirmationDialog.open = false; onDelete()"
>
    <p>{{ 'payroll.deductions.areYouSureYouWishToDeleteThisDeduction' | appTranslate }}</p>
</ui-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header
        [title]="deduction.name"
        [back]="true"
        [backRoute]="'/payroll/deductions'"
        [contextMenu]="!route.snapshot.data.isPayrollPending"
        [menuService]="payrollDeductionsMenuService"
    >
        <app-context-item
            label="{{ 'payroll.deductions.delete' | appTranslate }}"
            (click)="deleteConfirmationDialog.open = true"
        ></app-context-item>
    </app-header>

    <!-- Disabled Banner -->
    <ui-banner *ngIf="route.snapshot.data.isPayrollPending" class="margin-bottom-2" variant="warning">
        <p class="flag-content">{{ 'payroll.deductions.pendingPayrollNotice' | appTranslate }}</p>
    </ui-banner>

    <div class="app-grid">
        <ui-card class="columns-8">
            <app-segment-header
                title="{{ 'payroll.deductions.summary' | appTranslate }}"
                (edit)="onEdit()"
                [allowEdit]="!route.snapshot.data.isPayrollPending"
            ></app-segment-header>
            <div class="app-grid">
                <div class="columns-3">{{ 'payroll.deductions.deductionType' | appTranslate | i18nLabel }}</div>
                <div class="columns-9">{{ deduction.deductionType?.displayName }}</div>
            </div>
            <div class="app-grid margin-top-3">
                <div class="columns-3">{{ 'payroll.deductions.deductionName' | appTranslate | i18nLabel }}</div>
                <div class="columns-9">{{ deduction.name }}</div>
            </div>
            <div class="app-grid margin-top-3">
                <div class="columns-3">{{ 'payroll.deductions.glCodePayable' | appTranslate | i18nLabel }}</div>
                <div class="columns-9">{{ deduction.glCodePayable }}</div>
            </div>
        </ui-card>
        <ui-card class="columns-4">
            <app-deduction-taxation [deductionType]="deductionType"></app-deduction-taxation>
        </ui-card>
    </div>
</div>
